<template>
  <div class="text-left">
    <div class="text-center" style="height:570px; overflow-y:auto;">
      <b-spinner
        v-if="isLoading"
        type="grow"
        class="text-center"
        style="margin-top: 10%; position:absolute;"
        variant="primary"
      ></b-spinner>
      <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-brand href="#" class="text-dark">
          <strong>{{clientData && clientData.company_name}} - Manage Custom Fields</strong>
        </b-navbar-brand>
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button
              class="my-2 my-sm-0 mr-2"
              variant="outline-primary"
              size="sm"
              @click="showAddModal"
            >
              <font-awesome-icon icon="plus" />
            </b-button>
            <b-button
              variant="outline-info"
              size="sm"
              style="margin-right:30px;"
              @click="reloadTable"
            >
              <font-awesome-icon icon="sync" />
            </b-button>
            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-nav-form>
        </b-navbar-nav>
      </b-navbar>

      <b-table
        class="mx-1"
        sticky-header="calc(100vh - 200px)"
        ref="table"
        bordered
        id="users-data-table"
        :busy.sync="isLoading"
        :items="myProvider"
        :fields="fields"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        responsive="sm"
      >
        <template v-slot:cell(tp_customatt_values)="data">
          <div
            v-for="(dataValues,index) in data.item.tp_customatt_values"
            :key="index"
          >{{ dataValues.tp_values+',' }}</div>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button class="mr-2" type="button" @click="editField(data)" variant="info">
            <font-awesome-icon
              v-b-tooltip.hover
              title="Edit Field"
              class="mr-1 text-light"
              icon="edit"
            />Edit
          </b-button>
          <b-button type="button" variant="danger" @click="activeDeleteModal(data)">
            <font-awesome-icon
              v-b-tooltip.hover
              title="Delete Field"
              class="mr-1 text-light"
              icon="trash"
            />Delete
          </b-button>
        </template>
      </b-table>
      <b-row>
        <b-col cols="2">
          <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
        </b-col>
        <b-col>
          <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            aria-controls="users-data-table"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      :title="editForm ? 'Edit Fields' : 'Add Fields'"
      id="bv-modal-newform"
      size="xl"
      v-model="showAddFieldsModal"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div>
        <b-form v-if="!submiting && !responseSuccess">
          <b-row>
            <b-col cols="6">
              <b-form-group>
                <b-form-checkbox
                  v-model="form.includeCaField"
                  value="1"
                >Include Field in All Due Diligence Reports</b-form-checkbox>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="form.includeSrField" value="1">Set as Special Field</b-form-checkbox>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="form.includeRoField" value="1">Readonly</b-form-checkbox>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="form.displayInTable" value="1">Display in table view</b-form-checkbox>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="form.tpIsEdit" value="1">Editable</b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group>
                <b-form-checkbox v-model="form.tpIsFilter" value="1">Filterable</b-form-checkbox>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="form.tpIsSearch" value="1">Searchable</b-form-checkbox>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="form.tpDisplayInReports" value="1">Display In Reports</b-form-checkbox>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="form.tpPriIndicator" value="1">PRI Indicator</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group>
            <b-row>
              <b-col cols="3">
                <label>Sequence Number :</label>
              </b-col>
              <b-col cols="9">
                <b-form-input v-model="form.sequenceNumber" type="number"></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group>
            <b-row>
              <b-col cols="3">
                <label>
                  Field Name :
                  <span class="text-danger">*</span>
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-input
                  v-model="$v.form.fieldName.$model"
                  :state="$v.form.fieldName.$dirty ? !$v.form.fieldName.$error : null"
                  aria-describedby="input-live-help input-live-feedback"
                  type="text"
                  placeholder="Enter Field Name"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group>
            <b-row>
              <b-col cols="3">
                <label>
                  Is Required :
                  <span class="text-danger">*</span>
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-select
                  v-model="$v.form.isRequire.$model"
                  :state="$v.form.isRequire.$dirty ? !$v.form.isRequire.$error : null"
                  aria-describedby="input-live-help input-live-feedback"
                  :options="isRequireOptions"
                  class="mb-3"
                ></b-form-select>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group>
            <b-row>
              <b-col cols="3">
                <label>
                  Data Type :
                  <span class="text-danger">*</span>
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-select
                  v-model="$v.form.dataType.$model"
                  :state="$v.form.dataType.$dirty ? !$v.form.dataType.$error : null"
                  aria-describedby="input-live-help input-live-feedback"
                  :options="dataTypeOptions"
                  class="mb-3"
                ></b-form-select>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group
            v-if="form.dataType != 'Text' && form.dataType != 'Date' && form.dataType != 'Country List'"
          >
            <b-row>
              <b-col cols="3">
                <label>Data Values :</label>
              </b-col>
              <b-col cols="9">
                <b-row>
                  <b-col cols="6">
                    <label>Label</label>
                  </b-col>
                  <b-col cols="6">
                    <label>
                      Score
                      <span class="text-muted">(Max Score 100)</span>
                    </label>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="10">
                    <div v-for="(cloenFields,index) in dataValuesArray" :key="index">
                      <b-row class="mt-2">
                        <b-col cols="6">
                          <b-form-input
                            :class="getValidationColor ? 'border border-danger rounded' : null"
                            @input="checkCustomATValidation()"
                            v-model="form.dataArrayLabel[index]"
                            type="text"
                          ></b-form-input>
                        </b-col>
                        <b-col cols="6">
                          <b-input-group>
                            <b-form-input
                              v-model="form.dataArrayValue[index]"
                              type="number"
                              max="100"
                            ></b-form-input>
                            <template v-slot:append>
                              <b-button
                                variant="outline-danger"
                                v-if="index > 0"
                                class="btn btn-outline-danger btn-sm"
                                @click="onDeleteOption(index)"
                              >
                                <i class="fa fa-trash"></i>
                              </b-button>
                            </template>
                          </b-input-group>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                  <b-col cols="1">
                    <b-button class="mt-2" variant="primary" @click="addOption">
                      <i class="fa fa-plus"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form-group>
        </b-form>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{ editForm ? 'Your Fields is being updating......' : 'Your Fields is being added......' }}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ editForm ? 'Your Fields has been updated successfully.' : 'Your Fields has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          variant="outline-danger"
          @click="resetForm"
        >{{!submiting && responseSuccess ? 'Close' : 'Cancel' }}</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="checkValidation"
        >{{ editForm ? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Delete Field"
      v-model="showDeleteFieldModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <p>Are you sure you want to delete this field ?</p>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Field is being deleting......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Field has been deleted successfully.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button @click="resetDeleteModal">Close</b-button>
        <b-button v-if="!submiting && !responseSuccess" variant="danger" @click="deleteField()">
          <font-awesome-icon
            v-b-tooltip.hover
            title="Delete Field"
            class="mr-1 text-light"
            icon="trash"
          />Yes
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { HTTP } from "../../utils/HTTP";
import uid from "uid";
export default {
  name: "ClientProfileManageCustomFields",
  mixins: [validationMixin],
  components: {},
  data() {
    return {
      sNumber: null,
      showDeleteFieldModal: false,
      renderOptions: [],
      fieldId: null,
      editForm: false,
      form: {
        includeCaField: null,
        includeSrField: null,
        includeRoField: null,
        displayInTable: null,
        tpIsEdit: 1,
        tpIsFilter: 1,
        tpIsSearch: 1,
        tpDisplayInReports: null,
        tpPriIndicator: null,
        sequenceNumber: null,
        fieldName: null,
        isRequire: null,
        dataValues: null,
        dataLabels: null,
        dataType: "Dropdown",
        dataArrayLabel: [],
        dataArrayValue: []
      },
      dataValuesArray: [1],
      showAddFieldsModal: false,
      dataTypeOptions: [
        {
          value: "Dropdown",
          text: "Dropdown"
        },
        {
          value: "Multiselect",
          text: "Multiselect"
        },
        {
          value: "Text",
          text: "Text"
        },
        {
          value: "Date",
          text: "Date"
        },
        {
          value: "Country List",
          text: "Country List"
        }
      ],
      isRequireOptions: [
        {
          value: null,
          text: "-- Please select an option --"
        },
        {
          value: 0,
          text: "No"
        },
        {
          value: 1,
          text: "Yes"
        }
      ],
      clientData: null,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: false,
      pageOptions: [5, 10, 25, 50, 75, 100],
      items: [],
      isLoading: false,
      submiting: false,
      responseSuccess: false,
      filter: null,
      fields: [
        {
          key: "tp_sequence",
          label: "Sequence",
          sortable: true
        },
        {
          key: "tp_customatt",
          label: "Custom Field",
          sortable: true
        },
        {
          key: "tp_type",
          label: "Data Type",
          sortable: true
        },
        {
          key: "tp_customatt_values",
          label: "Data Values",
          sortable: false
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false
        }
      ],
      customAtFormValueValidation: true,
      getValidationColor: false
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  validations: {
    form: {
      fieldName: {
        required
      },
      isRequire: {
        required
      },
      dataType: {
        required
      }
    }
  },
  mounted() {
    this.getClientCustomPriFields();
  },
  methods: {
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "users-data-table");
    },
    async getClientCustomPriFields() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      try {
        let result = await HTTP(
          "get",
          "v1/pri/getclientcustomprifields/" + this.$route.params.id,
          null,
          {
            Authorization: token
          },
          null,
          true
        );
        this.clientData = result.data.client;
        this.isLoading = false;
      } catch {
        this.isLoading = false;
        this.showErrorToast = true;
      }
    },
    async myProvider() {
      // let formData = {
      //   filter: this.filter,
      //   sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
      //   per_page: this.perPage,
      //   page: this.currentPage
      // };

      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP(
        "post",
        "v1/clients/custom/fields/" + this.$route.params.id,
        {
          Authorization: token
        }
      );
      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    },
    resetForm() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.form.fieldName = null;
      this.form.sequenceNumber = null;
      this.form.dataType = "Dropdown";
      this.form.includeSrField = null;
      this.form.isRequire = null;
      this.form.includeCaField = null;
      this.form.tpDisplayInReports = null;
      this.form.tpPriIndicator = null;
      this.form.tpIsEdit = 1;
      this.form.tpIsFilter = 1;
      this.form.tpIsSearch = 1;
      this.form.includeRoField = null;
      this.form.displayInTable = null;
      this.form.dataValues = null;
      this.form.dataLabels = null;
      this.form.dataArrayLabel = [];
      this.form.dataArrayValue = [];
      this.$v.$reset();
      this.dataValuesArray = [1];
      this.reloadTable();
      this.editForm = false;
      this.showAddFieldsModal = false;
    },
    checkCustomATValidation() {
      this.customAtFormValueValidation = false;
      this.getValidationColor = false;
    },
    addOption() {
      if (this.customAtFormValueValidation) {
        this.getValidationColor = true;
      } else if (this.customAtFormValueValidation == false) {
        this.customAtFormValueValidation = true;
        this.dataValuesArray.push(1);
      }
      // this.dataArrayLabel.push({
      //   value: null,
      //   label: null
      // });
    },
    onDeleteOption(index) {
      this.dataValuesArray.splice(this.dataValuesArray.indexOf(index), 1);
      this.form.dataArrayLabel.splice(
        this.form.dataArrayLabel.indexOf(index),
        1
      );
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else if (this.editForm) {
        this.updateField();
      } else {
        this.addCompany();
      }
    },
    showAddModal() {
      this.editForm = false;
      this.showAddFieldsModal = true;
    },
    async addCompany() {
      let formData = {
        attributeName: this.form.fieldName,
        sequenceNumber: this.form.sequenceNumber,
        dataType: this.form.dataType,
        includeSRfield: this.form.includeSrField,
        tp_is_required: this.form.isRequire,
        tp_pri_indicator: this.form.tpPriIndicator,
        tp_is_edit: this.form.tpIsEdit,
        tp_is_filter: this.form.tpIsFilter,
        tp_is_search: this.form.tpIsSearch,
        includeROfield: this.form.includeRoField,
        display_in_table: this.form.displayInTable,
        dataLabels: this.form.dataArrayLabel,
        dataValues: this.form.dataArrayValue
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "v1/clients/add/custom/field/" + this.$route.params.id,
          formData,
          {
            Authorization: token
          }
        );
        this.reloadTable();
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (error) {
        this.isLoading = false;
        this.submiting = false;
      }
    },
    editField(data) {
      let dataItem = data.item;
      this.editForm = true;
      this.showAddFieldsModal = true;
      this.fieldId = dataItem.id;
      this.form.fieldName = dataItem.tp_customatt;
      this.form.sequenceNumber = dataItem.tp_sequence;
      this.form.dataType = dataItem.tp_type;
      this.form.includeSrField = dataItem.tp_specialrole;
      this.form.isRequire = dataItem.tp_is_required;
      this.form.tpPriIndicator = dataItem.tp_pri_indicator;
      this.form.tpIsEdit = dataItem.tp_is_edit;
      this.form.tpIsFilter = dataItem.tp_is_filter;
      this.form.tpIsSearch = dataItem.tp_is_search;
      this.form.includeRoField = dataItem.tp_readonly;
      this.form.displayInTable = dataItem.tp_displayintable;
      this.dataValuesArray = [];

      dataItem.tp_customatt_values.map((value, index) => {
        this.dataValuesArray.push(index);
        this.form.dataArrayLabel.push(value.tp_values);
        this.form.dataArrayValue.push(value.tp_values_meta);
      });
    },
    async updateField() {
      let formData = {
        eid: this.fieldId,
        attributeName: this.form.fieldName,
        sequenceNumber: this.form.sequenceNumber,
        dataType: this.form.dataType,
        includeSRfield: this.form.includeSrField,
        tp_is_required: this.form.isRequire,
        tp_pri_indicator: this.form.tpPriIndicator,
        tp_is_edit: this.form.tpIsEdit,
        tp_is_filter: this.form.tpIsFilter,
        tp_is_search: this.form.tpIsSearch,
        includeROfield: this.form.includeRoField,
        display_in_table: this.form.displayInTable,
        dataValues: this.form.dataArrayValue,
        dataLabels: this.form.dataArrayLabel
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "v1/clients/update/custom/field/" + this.$route.params.id,
          formData,
          {
            Authorization: token
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (error) {
        this.isLoading = false;
        this.submiting = false;
      }
    },
    activeDeleteModal(data) {
      this.fieldId = data.item.id;
      this.sNumber = data.item.tp_sequence;
      this.showDeleteFieldModal = true;
    },
    async deleteField() {
      let formData = {
        eid: this.fieldId,
        sequenceNumber: this.sNumber
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "v1/clients/delete/custom/field/" + this.$route.params.id,
          formData,
          {
            Authorization: token
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (error) {
        this.isLoading = false;
        this.submiting = false;
      }
    },
    resetDeleteModal() {
      this.reloadTable();
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
      this.showDeleteFieldModal = false;
    }
  }
};
</script>

<style scoped>
</style>
